import { useTransientVisibility } from "../../../../fusion/Contexts/VisualContext";
import { useIntegration } from "../../../contexts/IntegrationContext";

import { Button, Modal } from "cai-fusion";

const DeleteIntegrationModal = () => {
    const { currIntegration, setCurrIntegration, deleteIntegration } = useIntegration();
    const { visibilityStates, hide } = useTransientVisibility();

    return (
        <Modal
            id="delete-modal"
            isHidden={ !visibilityStates.DeleteIntegrationModal }
            clickOutsideToClose={ true }
            title="Delete Integration"
            onClose={(e) => {
                hide('DeleteIntegrationModal');
                e.preventDefault();
            }}
            actions={
                <>
                    <Button outline onClick={(e) => { e.preventDefault(); setCurrIntegration(undefined); hide('DeleteIntegrationModal'); }} children="Cancel"/>
                    <Button danger onClick={(e) => { e.preventDefault(); deleteIntegration(); hide('DeleteIntegrationModal'); }} children="Delete Integration"/>
                </>
            }
        >
            <div className="l-row">
                <div className="l-one-col">
                    <p><strong>{`Are you sure you want to delete ${currIntegration?.name ? (`"` + currIntegration.name + `"`) : "this integration"}?`}</strong></p>
                    <p>Deleting an integration cannot be undone. Please double-check you have selected the correct one! Due to the significance of integrations, it is also important to make sure nothing will break following the deletion.</p>
                </div>
            </div>
        </Modal>
    )
}

export default DeleteIntegrationModal;